import { Switch, Route as RouteComponent } from 'react-router';

import ProtectedRoute from './protectedRoute';
import { Route as RouteType } from './routes';

interface Props {
  routes: RouteType[];
  customProps?: { [key: string]: any };
}

export const RouteRender = ({ routes, customProps }: Props) => {
  return (
    <Switch>
      {routes.map((route, i) =>
        !route.commonPageData.visibleForAnonym ? (
          <ProtectedRoute
            key={i}
            exact={route.exact}
            path={route.path}
            component={route.component}
            isInternal={route.isInternal}
            customProps={customProps}
          />
        ) : (
          <RouteComponent
            key={i}
            exact={route.exact}
            path={route.path}
            render={(props) => <route.component customProps={customProps} {...props} />}
          />
        )
      )}
    </Switch>
  );
};
